import { useEffect, useState } from "react";
import { routeLocationFomoCouponGet } from "@devowl-wp/api-real-commerce";
import { getAffiliateFromStorage } from "../others/getAffiliateFromStorage.js";
import { realCommerceRequest } from "../utils/realCommerceRequest.js";
/**
 * Check, if a coupon is available for a given coupon from remote Real Commerce.
 * Return `undefined` if no coupon available.
 */ function useFomoCoupon(productId) {
    const [coupon, setCoupon] = useState();
    useEffect(()=>{
        async function fetch() {
            try {
                setCoupon((await realCommerceRequest({
                    location: routeLocationFomoCouponGet,
                    params: {
                        productId
                    }
                })).fomoCoupon);
            } catch (e) {
            // Silence is golden.
            }
        }
        // Do not fetch coupon if affiliate program is active
        if (getAffiliateFromStorage()) {
            return;
        }
        fetch();
    }, [
        productId
    ]);
    return coupon;
}
export { useFomoCoupon };
